import { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { StyledFlipOnScrollImage } from './FlipOnScrollImage.styled';
import * as Sentry from '@sentry/nextjs';

export default function FlipOnScrollImage({
  className = '',
  frontImage,
  backImage,
}) {
  const [rotation, setRotation] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      try {
        if (ref.current) {
          const rect = ref.current.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          const middleScreen = windowHeight / 2;

          if (rect.top < middleScreen) {
            setRotation(180);
          } else {
            setRotation(0);
          }
        }
      } catch (e) {
        Sentry.captureException(e);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <StyledFlipOnScrollImage ref={ref} className={className}>
      <motion.div
        className="images-container"
        animate={{ rotateY: rotation }}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
        style={{ transformStyle: 'preserve-3d' }}
      >
        <div className="front-image">
          <img src={frontImage} alt="Front" />
        </div>
        <div className="back-image">
          <img src={backImage} alt="Back" />
        </div>
      </motion.div>
    </StyledFlipOnScrollImage>
  );
}
